import * as React from "react";
import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import LoadingSpinner from "../LoadingSpinner";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import {getDropdownData, getOtherRefSearchDropdown} from "../../api/keyvalue";
import Grid from "../Grid";
import useUserCompany from "../../hooks/useUserCompany";
import {getUserByStkData} from "../../api/deviceRegistrationApi";

const DeviceBulkRegister = forwardRef(
    (
        {
            style = {},
            positionStyle = {},
            value,
            heading = "Device Register",
            isLoading,
            showQrCloseButton = false,
            handleQRPopUpCloseChange = () => {},
            currentContactErrors,
        },
        ref
    ) =>{
        const [deviceBulkReg, setDeviceBulkReg] = useState({
            dbrStakeholder:"",
            dbrStakeholderName:"",
            dbrAlertType:"",
        });

        const [active , setActive] = useState(1);
        const userCompany = useUserCompany();

        //Grid
        const [userStkList, setUserStkList] = useState([]);

        // flags
        const [searchFieldReset, setSearchFieldReset] = useState(false);
        const [fieldReset, setFieldReset] = useState(false);
        const [gridLoading, setGridLoading] = useState(false);

        //dropdown
        const [notificationType, setNotificationType] = useState([]);

        // check box
        const [selectedRows, setSelectedRows] = useState([]);
        const gridRef = useRef();

        const [currentErrors, setCurrentErrors] = useState({});
        useEffect(() => {
            setCurrentErrors(currentContactErrors);
        }, [currentContactErrors]);

        useEffect(() => {
            (async () => {

                const alertData = await getDropdownData("alert_type");
                const alertType = alertData.filter(item => [3, 4].includes(item.key));
                setNotificationType(alertType);
            })();
        }, []);

        const handleSelectionChanged = useCallback(() => {
            const selectedData = gridRef.current.getSelectedData();
            setActive(1);
            setSelectedRows(selectedData);
        }, []);

        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
        );
        useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
        }, [userCompany]);

        const getStkData = async (data) =>{
            setGridLoading(true)
            const response = await getUserByStkData(data)
            setUserStkList((prevState) => [
                ...prevState,
                ...(Array.isArray(response) ? response : [response]),
            ]);

            setDeviceBulkReg((prevState) => ({
                ...prevState,
                dbrStakeholder: {
                    ...prevState.dbrStakeholder,
                    [data.key]: data.title,
                },
            }));
            setGridLoading(false)
        }

        useImperativeHandle(ref, () => ({
            getData: () => ({
                selectedList: selectedRows,
                otherData: deviceBulkReg
            }),
            reset: () =>{
                setFieldReset(true);
                setUserStkList([]);
                setDeviceBulkReg({
                    dbrStakeholder:"",
                    dbrStakeholderName:"",
                    dbrAlertType:"",
                })
            }

        }));

        return(
            <>
                <div
                    style={{
                        ...positionStyle,
                        padding: "10px 10px 10px 0",
                        justifyContent: "space-between",
                    }}
                >
                    {heading && <h3 style={{marginBottom: "10px"}}>{heading}</h3>}
                    <div style={{display: "flex", gap: "5px"}}>
                        {showQrCloseButton && (
                            <button
                                className="ui primary right floated button"
                                type="button"
                                onClick={(e) => {
                                    handleQRPopUpCloseChange()
                                }}
                                style={{display: "flex", alignItems: "center"}}
                            >
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        Close Bulk
                                    </div>
                                </div>
                            </button>
                        )}
                    </div>
                </div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form
                        className="ui form"
                        style={{overflowY: "auto"}}
                    >
                        <div className="ui segment">

                            <div className="two fields">

                                <SearchDropdown
                                    key={1}
                                    required={true}
                                    multiple={true}
                                    reset={fieldReset}
                                    setReset={setFieldReset}
                                    multiValueRemoveHandler={(key) => {
                                        setUserStkList(prev => {
                                            return prev.filter(item => item.ucsStkId.toString() !== key.toString());
                                        });
                                        setDeviceBulkReg((prevState) => {
                                            const { [key]: _, ...rest } = prevState.dbrStakeholder;
                                            return { ...prevState, dbrStakeholder: rest };
                                        });
                                    }}

                                    onResultSelect={(data) => {
                                        getStkData(data);
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: "Transporter",
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_stakeholder",
                                        primaryKey: "stk_id",
                                        fieldName: "stk_name",
                                        id: deviceBulkReg.dbrStakeholder,
                                    }}
                                    error={currentErrors.dbrStakeholder}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { dbrStakeholder: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    label="Stakeholder"
                                />
                                <Dropdown
                                    label="Notification Type"
                                    options={notificationType}
                                    placeholder="Notification Type"
                                    style={{height: "20px"}}
                                    value={deviceBulkReg.dbrAlertType}
                                    onChange={(e, data) => {
                                        setDeviceBulkReg((prevState) => ({
                                            ...prevState,
                                            dbrAlertType: data.value,
                                        }));
                                    }}
                                    error={currentErrors.dbrAlertType}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { dbrAlertType: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    required={true}
                                />

                            </div>
                            <div>
                                {gridLoading ? (
                                    <LoadingSpinner />
                                ) : (
                                <div className="ui segment">
                                    <Grid
                                        style={{width:"70vw"}}
                                        ref={gridRef}
                                        multiRowSelection={true}
                                        onSelectionChanged={handleSelectionChanged}
                                        heading="Device Bulk Register"
                                        isLoading={gridLoading}
                                        content={userStkList}
                                        config={[
                                            {
                                                headerName: "Id",
                                                field: "ucsUserId",
                                                sort: "desc",
                                                hide: true,
                                            },
                                            {
                                                headerName: "Stakeholder",
                                                field: "ucsStkName",
                                                headerCheckboxSelection: true,
                                                checkboxSelection: true,
                                            },
                                            {
                                                headerName: "User Name",
                                                field: "ucsUsername",

                                            },
                                            {
                                                headerName: "Phone",
                                                field: "contactNo",
                                            },
                                            {
                                                headerName: "Email",
                                                field: "email",
                                            }
                                        ]}

                                    />
                                </div>
                                )}
                            </div>
                        </div>
                    </form>
                )}
            </>
        )
    }

)
export default DeviceBulkRegister;
